import { render } from "./PageHistChamados.vue?vue&type=template&id=7cf8bb74&scoped=true"
import script from "./PageHistChamados.vue?vue&type=script&lang=js"
export * from "./PageHistChamados.vue?vue&type=script&lang=js"

import "./PageHistChamados.vue?vue&type=style&index=0&id=7cf8bb74&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf8bb74"]])

export default __exports__